import { defineComponent as _defineComponent } from 'vue'
import { ObjectType, StreamingChartsTitlesEdge } from '@/@types/graphql-types';
import PictureComp from '@/components/picture/PictureComp.vue';
import SingleRankingDisplay from '@/components/streaming-charts/SingleRankingDisplay.vue';
import OffersDisplay from '@/components/streaming-charts/OffersDisplay.vue';
import { computed, ref } from 'vue';
import { useI18n } from '@/helpers/composables/useI18n';

import { faTwitter, faFacebook } from '@fortawesome/free-brands-svg-icons';
import { faCopy as faCopyRegular } from '@fortawesome/free-regular-svg-icons';
import { ShareMethod } from '@/enums/share-methods';
import { addToast } from '@/helpers/toast/toast-helper';
import { getVm } from '@/helpers/vm-helper';
import { ClickoutUrl } from '@/helpers/clickout-helper';
interface StreamingChartsListItemProps {
	title: StreamingChartsTitlesEdge;
	index: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'StreamingChartsListItem',
  props: {
    title: null,
    index: null
  },
  setup(__props: any) {

const props = __props as { title: StreamingChartsTitlesEdge, index: number }

const twitterIcon = faTwitter;
const facebookIcon = faFacebook;
const farCopyIcon = faCopyRegular;

const { t, tc } = useI18n();



const IMAGESCALER_URL = JW_CONFIG.IMAGESCALER_URL;

const expandRow = ref(false);

const toggleRow = () => {
	expandRow.value = !expandRow.value;
};

const getTitleName = (title: StreamingChartsTitlesEdge) => {
	if (props.title.node.objectType === ObjectType.ShowSeason) {
		// @ts-ignore
		return props.title?.node?.show?.content?.title;
	}
	return props.title?.node?.content?.title;
};

const getSeasonNumber = (title: StreamingChartsTitlesEdge) => {
	// @ts-ignore
	return `${t('WEBAPP_SEASON')} ${props.title?.node?.content?.seasonNumber}`;
};

const padNumber = (number: number) => {
	if (number.toString().length < 2) {
		return '0' + number;
	} else {
		return number;
	}
};

const numberOfDays = (days: number) => {
	if (!days) return '--';
	return days === 1 ? `${days} ${tc('WEBAPP_DAY')}` : t('WEBAPP_X_DAYS', { number: days });
};

const getShareUrl = (titleFullPath: string): string => {
	const standardWebURL = new URL(titleFullPath, `https://www.${JW_CONFIG.DOMAIN}`).href;
	return new ClickoutUrl({ standardWebURL }).set('utm_source', 'share').set('utm_medium', 'web').toString();
};

const share = (
	titleDetails: { titleId: number; titleObjectType: ObjectType; titleFullPath: string; titleName: string },
	method?: ShareMethod
) => {
	const shareUrl: string = getShareUrl(titleDetails.titleFullPath);
	const shareText: string = `${titleDetails.titleName}:` ?? document.title;

	switch (method) {
		case ShareMethod.FACEBOOK:
			{
				const url: string = new URL(
					`?u=${shareUrl}&t=${shareText}`,
					'http://www.facebook.com/sharer/sharer.php'
				).toString();
				window.open(url);
			}
			break;
		case ShareMethod.TWITTER:
			{
				const url: string = new URL(
					`?url=${shareUrl}&text=${shareText}`,
					'https://twitter.com/intent/tweet'
				).toString();
				window.open(url);
			}
			break;
		default:
			if (navigator && navigator.clipboard) {
				navigator.clipboard.writeText(shareUrl);
				addToast({ message: getVm().$t('WEBAPP_COPIED_TO_CLIPBOARD') });
			}
	}
};

return { __sfc: true,twitterIcon, facebookIcon, farCopyIcon, t, tc, props, IMAGESCALER_URL, expandRow, toggleRow, getTitleName, getSeasonNumber, padNumber, numberOfDays, getShareUrl, share, PictureComp, SingleRankingDisplay, OffersDisplay, faTwitter, faFacebook }
}

})